"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const components_1 = require("utils/components");
const hooks_1 = require("../../../wordTable/list/hooks");
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_router_dom_1 = require("react-router-dom");
const updateScript_1 = require("@/utils/updateScript");
const index_1 = require("../../../../../index");
function WordTableSidePanel({ projectId, langId, condition, }) {
    // Keep track of items we've toggled off
    const removedItemsRef = (0, react_1.useRef)(new Set());
    const { list, loading, fetching } = (0, hooks_1.useWordTableListData)({
        projectId,
        langId,
        condition,
    });
    // Filter out any removed items at render time using useMemo
    const filteredList = (0, react_1.useMemo)(() => {
        if (!list || !removedItemsRef.current.size) {
            return list;
        }
        return list.filter((item) => !removedItemsRef.current.has(item.scriptId));
    }, [list]);
    const handleSwitchChange = (e, script) => __awaiter(this, void 0, void 0, function* () {
        const isChecked = e.target.checked;
        // Track item status (no state updates to avoid re-renders)
        if (!isChecked) {
            removedItemsRef.current.add(script.scriptId);
        }
        else {
            removedItemsRef.current.delete(script.scriptId);
        }
        try {
            // Actual server update
            yield (0, updateScript_1.updateScript)({
                projectId,
                scriptId: script.scriptId,
                segmentId: script.segmentId,
                data: Object.assign(Object.assign({}, script), { shouldIncludedIntoSegmentLevelWordTable: isChecked }),
            });
            // Wait a bit for database to update
            yield new Promise((resolve) => setTimeout(resolve, 300));
        }
        catch (error) {
            console.error("Error updating script:", error);
        }
    });
    return (react_1.default.createElement(components_1.SidePanel, { title: react_1.default.createElement("i", { className: "mdi mdi-book-open", "data-tooltip-id": "tooltip", "data-tooltip-content": "\u5358\u8A9E\u30EA\u30B9\u30C8" }), kind: "word-table", priority: 7 },
        react_1.default.createElement("section", { className: "sidePanelTitle" }, "\u5358\u8A9E\u30EA\u30B9\u30C8"),
        react_1.default.createElement("section", null,
            (loading || fetching) && react_1.default.createElement(components_1.Loading, null),
            react_1.default.createElement("ul", null, filteredList.map((item) => {
                var _a;
                return (react_1.default.createElement("li", { key: item.scriptId, style: { padding: 10 }, className: "border-bottom" },
                    react_1.default.createElement("span", { className: "d-flex justify-content-between" },
                        react_1.default.createElement("span", null,
                            item.segmentId && (react_1.default.createElement(react_router_dom_1.Link, { to: (0, index_1.resolveRoute)("UPDATE_SEGMENT_SCRIPT", {
                                    scriptId: item.scriptId,
                                    projectId,
                                    // @ts-ignore
                                    segmentId: item.segmentId,
                                }, { retainSearchParams: true }) },
                                react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", style: { whiteSpace: "nowrap" } },
                                    react_1.default.createElement("i", { className: "mdi mdi-eye-outline" })))),
                            react_1.default.createElement("b", { className: "ms-2" }, item.text),
                            langId && (react_1.default.createElement("p", { style: { marginTop: 8 } }, (_a = item.translations) === null || _a === void 0 ? void 0 : _a[langId]))),
                        item.shouldIncludedIntoSegmentLevelWordTable && (react_1.default.createElement("div", { className: "form-check form-switch" },
                            react_1.default.createElement("input", { className: "form-check-input", type: "checkbox", role: "switch", defaultChecked: 
                                // @ts-ignore
                                item === null || item === void 0 ? void 0 : item.shouldIncludedIntoSegmentLevelWordTable, onChange: (e) => handleSwitchChange(e, item), "data-tooltip-id": "tooltip", "data-tooltip-html": `<div class="tooltip-content">この単語が含まれている文章は、常にこの単語を参照訳として利用します。通常の参照訳は、相対的に一致度の高いものだけが利用されます</div>` }))))));
            })))));
}
exports.default = WordTableSidePanel;
